import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import {
    listfinancialyears,
    createfinancialyear,
    updatefinancialyear,
    activatefinancialyear,
    closefinancialyear,
    deletefinancialyear,
    getyearstatistics,
    performyearendclosing
} from "../../../services/admin";
import { toast } from "react-toastify";
import moment from "moment";
import Swal from "sweetalert2";

export default function FinancialYear() {
    const [years, setYears] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [editingYear, setEditingYear] = useState(null);
    const [formData, setFormData] = useState({
        year_name: "",
        start_date: "",
        end_date: "",
        is_active: false,
        remarks: ""
    });

    const columnDefs = [
        {
            headerName: "Year Name",
            field: "year_name",
            width: 250,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                const year = params.data;
                let html = <strong>{year.year_name}</strong>;
                return html;
            }
        },
        {
            headerName: "Start Date",
            field: "start_date",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return params.value ? moment(params.value).format('DD-MM-YYYY') : '-';
            }
        },
        {
            headerName: "End Date",
            field: "end_date",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return params.value ? moment(params.value).format('DD-MM-YYYY') : '-';
            }
        },
        {
            headerName: "Status",
            field: "is_closed",
            width: 130,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                if (params.data.is_closed) {
                    return (
                        <span className="badge bg-danger">
                            <i className="fa fa-lock"></i> Closed
                        </span>
                    );
                } else {
                    return (
                        <span className="badge bg-success">
                            <i className="fa fa-unlock"></i> Open
                        </span>
                    );
                }
            }
        },
        {
            headerName: "Vouchers",
            field: "voucher_count",
            width: 130,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                return (
                    <span className="badge bg-info">{params.value || 0}</span>
                );
            }
        },
        {
            headerName: "Remarks",
            field: "remarks",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <small>{params.value || '-'}</small>
                );
            }
        },
        {
            headerName: "Actions",
            field: "id",
            width: 250,
            sortable: false,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const year = params.data;
                if (!year) return "-";

                return (
                    <div>
                        {!year.is_closed && (
                            <>
                                {!year.is_active && (
                                    <button
                                        className="btn btn-sm btn-success me-1"
                                        onClick={() => window.handleActivateYear(year.id)}
                                        title="Activate Year"
                                    >
                                        <i className="fa fa-check"></i>
                                    </button>
                                )}

                                <button
                                    className="btn btn-sm btn-primary me-1"
                                    onClick={() => window.handleEditYear(year.id)}
                                    title="Edit Year"
                                >
                                    <i className="fa fa-edit"></i>
                                </button>

                                <button
                                    className="btn btn-sm btn-info me-1"
                                    onClick={() => window.handleYearEndClosingBtn(year.id)}
                                    title="Year-End Closing"
                                >
                                    <i className="fa fa-calculator"></i>
                                </button>

                                <button
                                    className="btn btn-sm btn-warning me-1"
                                    onClick={() => window.handleCloseYear(year.id)}
                                    title="Close Year"
                                >
                                    <i className="fa fa-lock"></i>
                                </button>
                            </>
                        )}

                        {year.voucher_count === 0 && !year.is_active && (
                            <button
                                className="btn btn-sm btn-danger"
                                onClick={() => window.handleDeleteYear(year.id)}
                                title="Delete Year"
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        )}

                        {year.is_closed && (
                            <span className="text-muted">
                                <small>
                                    Closed on {moment(year.closed_date).format("DD-MM-YYYY")}
                                </small>
                            </span>
                        )}
                    </div>
                );
            },
            // cellRenderer: function (params) {
            //     const year = params.data;
            //     let html = '';

            //     if (!year.is_closed) {
            //         if (!year.is_active) {
            //             html += `<button class="btn btn-sm btn-success me-1" onclick="window.handleActivateYear(${year.id})" title="Activate Year"><i class="fa fa-check"></i></button>`;
            //         }
            //         html += `<button class="btn btn-sm btn-primary me-1" onclick="window.handleEditYear(${year.id})" title="Edit Year"><i class="fa fa-edit"></i></button>`;
            //         html += `<button class="btn btn-sm btn-info me-1" onclick="window.handleYearEndClosingBtn(${year.id})" title="Year-End Closing"><i class="fa fa-calculator"></i></button>`;
            //         html += `<button class="btn btn-sm btn-warning me-1" onclick="window.handleCloseYear(${year.id})" title="Close Year"><i class="fa fa-lock"></i></button>`;
            //     }

            //     if (year.voucher_count === 0 && !year.is_active) {
            //         html += `<button class="btn btn-sm btn-danger" onclick="window.handleDeleteYear(${year.id})" title="Delete Year"><i class="fa fa-trash"></i></button>`;
            //     }

            //     if (year.is_closed) {
            //         html += `<span class="text-muted"><small>Closed on ${moment(year.closed_date).format('DD-MM-YYYY')}</small></span>`;
            //     }

            //     return html || '-';
            // }
        }
    ];

    useEffect(() => {
        // Expose functions to window for AG Grid button clicks
        window.handleActivateYear = (id) => {
            const year = years.find(y => y.id === id);
            if (year) handleActivate(year);
        };
        window.handleEditYear = (id) => {
            const year = years.find(y => y.id === id);
            if (year) handleEdit(year);
        };
        window.handleYearEndClosingBtn = (id) => {
            const year = years.find(y => y.id === id);
            if (year) handleYearEndClosing(year);
        };
        window.handleCloseYear = (id) => {
            const year = years.find(y => y.id === id);
            if (year) handleClose(year);
        };
        window.handleDeleteYear = (id) => {
            const year = years.find(y => y.id === id);
            if (year) handleDelete(year);
        };

        fetchYears();

        // Cleanup
        return () => {
            delete window.handleActivateYear;
            delete window.handleEditYear;
            delete window.handleYearEndClosingBtn;
            delete window.handleCloseYear;
            delete window.handleDeleteYear;
        };
    }, [years]);

    const fetchYears = () => {
        setLoading(true);
        listfinancialyears().then((res) => {
            if (res.status === true) {
                setYears(res.data);
            }
            setLoading(false);
        });
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.year_name || !formData.start_date || !formData.end_date) {
            toast.error("Please fill all required fields");
            return;
        }

        if (editingYear) {
            // Update
            updatefinancialyear(editingYear.id, formData).then((res) => {
                if (res.status === true) {
                    toast.success("Financial Year Updated Successfully");
                    fetchYears();
                    resetForm();
                } else {
                    toast.error(res.message || "Failed to update");
                }
            });
        } else {
            // Create
            createfinancialyear(formData).then((res) => {
                if (res.status === true) {
                    toast.success("Financial Year Created Successfully");
                    fetchYears();
                    resetForm();
                } else {
                    toast.error(res.message || "Failed to create");
                }
            });
        }
    };

    const handleEdit = (year) => {
        if (year.is_closed) {
            toast.error("Cannot edit a closed financial year");
            return;
        }
        setEditingYear(year);
        setFormData({
            year_name: year.year_name,
            start_date: moment(year.start_date).format('YYYY-MM-DD'),
            end_date: moment(year.end_date).format('YYYY-MM-DD'),
            is_active: year.is_active,
            remarks: year.remarks || ""
        });
        setShowForm(true);
    };

    const handleActivate = (year) => {
        if (year.is_closed) {
            toast.error("Cannot activate a closed financial year");
            return;
        }

        Swal.fire({
            title: 'Activate Financial Year?',
            text: `Activate ${year.year_name}? This will deactivate all other years.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, activate it!'
        }).then((result) => {
            if (result.isConfirmed) {
                activatefinancialyear(year.id).then((res) => {
                    if (res.status === true) {
                        toast.success("Financial Year Activated Successfully");
                        fetchYears();
                    } else {
                        toast.error(res.message || "Failed to activate");
                    }
                });
            }
        });
    };

    const handleYearEndClosing = (year) => {
        if (year.is_closed) {
            toast.error("Financial year is already closed");
            return;
        }

        Swal.fire({
            title: 'Perform Year-End Closing?',
            html: `
                <p><strong>Automated Year-End Closing for ${year.year_name}</strong></p>
                <p class="text-info">This will automatically:</p>
                <ul class="text-left">
                    <li>Close all Income and Expense accounts</li>
                    <li>Transfer net profit/loss to Retained Earnings</li>
                    <li>Create opening entries for next year</li>
                    <li>Mark the year as closed</li>
                </ul>
                <p class="text-danger"><strong>Warning:</strong> This action cannot be undone!</p>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, perform year-end closing!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                performyearendclosing(year.id).then((res) => {
                    if (res.status === true) {
                        const data = res.data;
                        const profitLoss = data.net_profit_loss >= 0 ? 'Profit' : 'Loss';
                        Swal.fire({
                            icon: 'success',
                            title: 'Year-End Closing Completed!',
                            html: `
                                <p><strong>Summary:</strong></p>
                                <ul class="text-left">
                                    <li>Total Income: ₹${parseFloat(data.total_income).toLocaleString('en-IN')}</li>
                                    <li>Total Expense: ₹${parseFloat(data.total_expense).toLocaleString('en-IN')}</li>
                                    <li>Net ${profitLoss}: ₹${Math.abs(parseFloat(data.net_profit_loss)).toLocaleString('en-IN')}</li>
                                    <li>Closing Voucher: ${data.closing_voucher.voucher_number}</li>
                                    ${data.next_year_created ? '<li>Opening entries created for next year</li>' : ''}
                                </ul>
                            `
                        });
                        fetchYears();
                    } else {
                        toast.error(res.message || "Failed to perform year-end closing");
                    }
                });
            }
        });
    };

    const handleClose = (year) => {
        if (year.is_closed) {
            toast.error("Financial year is already closed");
            return;
        }

        Swal.fire({
            title: 'Close Financial Year?',
            html: `
                <p>Are you sure you want to close <strong>${year.year_name}</strong>?</p>
                <p class="text-danger"><strong>Warning:</strong> This action cannot be undone!</p>
                <ul class="text-left">
                    <li>All draft vouchers must be posted or deleted first</li>
                    <li>No new transactions can be added to this year</li>
                    <li>The year will be marked as inactive</li>
                </ul>
                <p class="text-info"><strong>Tip:</strong> Use "Year-End Closing" button for automatic closing entries</p>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, close it!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                closefinancialyear(year.id).then((res) => {
                    if (res.status === true) {
                        toast.success("Financial Year Closed Successfully");
                        fetchYears();
                    } else {
                        toast.error(res.message || "Failed to close");
                    }
                });
            }
        });
    };

    const handleDelete = (year) => {
        if (year.voucher_count > 0) {
            toast.error(`Cannot delete: ${year.voucher_count} vouchers exist for this year`);
            return;
        }

        Swal.fire({
            title: 'Delete Financial Year?',
            text: `Delete ${year.year_name}? This cannot be undone!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                deletefinancialyear(year.id).then((res) => {
                    if (res.status === true) {
                        toast.success("Financial Year Deleted Successfully");
                        fetchYears();
                    } else {
                        toast.error(res.message || "Failed to delete");
                    }
                });
            }
        });
    };

    const resetForm = () => {
        setFormData({
            year_name: "",
            start_date: "",
            end_date: "",
            is_active: false,
            remarks: ""
        });
        setEditingYear(null);
        setShowForm(false);
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Financial Year Management</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Accounts</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Financial Year
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4 className="card-title">Financial Year Management</h4>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            {!showForm && (
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => setShowForm(true)}
                                                >
                                                    <i className="fa fa-plus"></i> Create New Year
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {showForm && (
                                        <div className="card mb-4">
                                            <div className="card-header bg-light">
                                                <h5>{editingYear ? 'Edit' : 'Create'} Financial Year</h5>
                                            </div>
                                            <div className="card-body">
                                                <form onSubmit={handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">
                                                                Year Name <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="year_name"
                                                                value={formData.year_name}
                                                                onChange={handleInputChange}
                                                                placeholder="e.g., FY 2024-25"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">
                                                                Start Date <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                name="start_date"
                                                                value={formData.start_date}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">
                                                                End Date <span className="text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                name="end_date"
                                                                value={formData.end_date}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <label className="form-label">Remarks</label>
                                                            <textarea
                                                                className="form-control"
                                                                name="remarks"
                                                                value={formData.remarks}
                                                                onChange={handleInputChange}
                                                                rows="2"
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                    {!editingYear && (
                                                        <div className="row">
                                                            <div className="col-md-12 mb-3">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        name="is_active"
                                                                        checked={formData.is_active}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                    <label className="form-check-label">
                                                                        Set as Active Year
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="row">
                                                        <div className="col-md-12 text-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary me-2"
                                                                onClick={resetForm}
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button type="submit" className="btn btn-primary">
                                                                <i className="fa fa-save"></i> {editingYear ? 'Update' : 'Create'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    )}

                                    {/* Financial Years Table */}
                                    <div className="ag-theme-alpine ag-style mt-2">
                                        <AgGridReact
                                            columnDefs={columnDefs}
                                            rowData={years}
                                            pagination={true}
                                            paginationPageSize={10}
                                            sortingOrder={["asc", "desc"]}
                                            suppressDragLeaveHidesColumns={true}
                                            domLayout="autoHeight"
                                        />
                                    </div>

                                    {/* Info Panel */}
                                    <div className="alert alert-info mt-4">
                                        <h6><i className="fa fa-info-circle"></i> Financial Year Management Tips:</h6>
                                        <ul className="mb-0">
                                            <li><strong>Active Year:</strong> Only one year can be active at a time. All new vouchers are created in the active year.</li>
                                            <li><strong>Closing Year:</strong> Before closing, ensure all draft vouchers are posted or deleted.</li>
                                            <li><strong>Closed Year:</strong> Once closed, no transactions can be added or modified for that year.</li>
                                            <li><strong>Deleting Year:</strong> Can only delete years with no vouchers.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
